export default {"src":"/_next/static/media/logo-white.2a1c8cbf.svg","height":61,"width":112};